import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { addPartnerChildren, editPartnerChildren } from 'actions/partnerChildrenForm'
import PartnerChildrenDisplayForm from 'views/PersonalInfo/PartnerChildrenDisplayForm'
// import moment from 'moment'
import { getEmployeeId } from 'utils/getEmployeeId'
import { format, parse } from 'date-fns'
import constants from 'constants'

class PartnerChildrenForm extends Component {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    forms: PropTypes.object,
    hide: PropTypes.func,
    id: PropTypes.string,
    modals: PropTypes.object,
    personalInfo: PropTypes.object.isRequired,
    selectedPartner: PropTypes.object,
  }
  static defaultProps = {
    hide: null,
    forms: null,
    modals: null,
    selectedPartner: null,
  }

  static defaultProps = {
    id: 'partnerChildrenForm',
  }

  _submit = (data) => {
    const formData = {
      employee_id: getEmployeeId(this.props.selectedPartner, this.props.currentUser),
      children_id: (data.children_id ? data.children_id : ''),
      full_name: (data.full_name ? data.full_name : ''),
      date_of_birth: (data.date_of_birth ? format(parse(data.date_of_birth, constants.DATE_FORMAT.STANDARD_AU_NOTIME, new Date()), constants.DATE_FORMAT.STANDARD_ISO) : ''),
    }
    if (data.children_id) {
      this.props.dispatch(editPartnerChildren(formData, this.props.id))
    } else {
      this.props.dispatch(addPartnerChildren(formData, this.props.id))
    }
  }

  render() {
    const {
      modals, hide, forms, id, personalInfo,
    } = this.props
    return (
      <PartnerChildrenDisplayForm
        dispatch={this.props.dispatch}
        forms={forms}
        handleSubmit={this._submit}
        hide={hide}
        id={id}
        modals={modals}
        personalInfo={personalInfo}
        title="Partner children details"
      />
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

const mapStateToProps = state => ({
  errorMessage: state.errorMessage,
  modals: state.modals,
  forms: state.forms,
  personalInfo: state.personalInfo,
  selectedPartner: (Object.keys(state.personalinfos.selectedPartner).length === 0 && sessionStorage.getItem('SelectedPartner') !== null ?
    JSON.parse(sessionStorage.getItem('SelectedPartner')) :
    state.personalinfos.selectedPartner),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PartnerChildrenForm))



// WEBPACK FOOTER //
// ./src/containers/PartnerChildrenForm.js